module.exports = __webpack_public_path__ + "img/bnZTvbHnlciHd0289dc0a46fc5b15b3363ffa78cf6c7_1640754774127.d0289dc0.png";